export default {"src":"/_next/static/media/assistant-fixer-with-small-grey-text-box.81488891.svg","height":332,"width":269};